import * as React from "react"
import {IconSeeker} from "@ui-seeker/core";

import {PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS} from "../constants";

export default function CheckIcon({ status, show, size="1.2rem" }) {
    if(!show)
        return <></>

    let icon = null
    let color = null

    if (status === PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS.NO_MATCH) {
        icon = 'square-xmark'
        color = 'error.main'
    }

    if (status === PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS.NO_DATE_MATCH) {
        icon = 'square-minus'
        color = 'disabled.light'
    }

    if (status === PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS.NO_POSITION_MATCH) {
        icon = 'circle'
        color = 'warning.main'
    }

    if (status === PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS.FULL_MATCH) {
        icon = 'square-check'
        color = 'success.main'
    }

    return <IconSeeker
        icon={icon}
        sx={{
            color: color,
            fontSize: size,
            position: 'absolute',
            zIndex: 1,
            bottom: 0,
            right: 0,
            backgroundColor: "white",
            backgroundSize: 'cover'
        }}
    />
}